import { BannerSecondary } from '@sbercloud/uikit-product-site-banner';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { ClickAnalyticsType } from 'src/types';

export function SubscribeBanner({
  clickAnalytics,
}: {
  clickAnalytics: (variables: ClickAnalyticsType) => void;
}) {
  const layoutType = useLayoutType();

  return (
    <BannerSecondary
      title="Выберите письма, которые хотите получать"
      description="Получайте информацию о лучших материалах прямо на почту"
      img="https://cdn.cloud.ru/backend/images/subscribe_banner.png"
      appearance="decor"
      layoutType={layoutType}
      buttons={[
        {
          label: 'Выбрать',
          href: '/subscription',
          target: '_blank',
          onClick: () => {
            clickAnalytics({
              action: `/subscription`,
              clickZone: 'body',
              clickElement: 'button',
              clickContent: 'Выбрать',
              uniqueId: `cloud-subscribe-button`,
              transitionType: 'inside-link',
              clickZoneCategory: 'site-body',
              transitionUrl: '/subscription',
              transitionTypeMetrics: 'internal',
            });
          },
        },
      ]}
    />
  );
}
